import { watchGuides } from '@/mocks/content';
import SectionHeading from './SectionHeading';

export default function WatchGuide() {
  return (
    <section id="guide" className="w-full bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-8">
        <SectionHeading
          kicker="How to Use"
          title="观影指南：四步找到今晚想看的片"
          desc="第一次来到本站也不需要摸索，按下面的顺序走一遍，几分钟就能从「不知道看什么」变成「已经选好了」。"
        />

        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
          {watchGuides.map((step, index) => (
            <div
              key={step.id}
              className="relative p-5 md:p-6 rounded-lg bg-background-100 border border-background-200"
            >
              <span className="absolute top-5 right-5 font-heading text-4xl text-background-300 leading-none">
                0{index + 1}
              </span>
              <span className="w-12 h-12 flex items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className={`${step.icon} text-2xl`} />
              </span>
              <h3 className="mt-4 text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>

        <div className="mt-8 flex flex-col md:flex-row items-center justify-between gap-4 p-5 md:p-6 rounded-lg bg-foreground-950">
          <div className="flex items-center gap-3">
            <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-500 text-foreground-950">
              <i className="ri-lightbulb-flash-line text-2xl" />
            </span>
            <div>
              <p className="text-sm md:text-base font-bold text-background-50">不想看长列表？直接去片库筛选</p>
              <p className="text-xs md:text-sm text-foreground-400">用类型标签 + 关键词，两步锁定想看的那部。</p>
            </div>
          </div>
          <a
            href="#library"
            className="inline-flex items-center gap-2 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-semibold whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            打开片库筛选
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}